const FULLSCREEN_ROOT = "fullscreen-root";
const FULLSCREEN_CLOSE_BUTTON = "fullscreen-close-button";
const FULLSCREEN_TOGGLE_BUTTON = "fullscreen-toggle-button";
const FULLSCREEN_IMAGE_ITEM = "fullscreen-image-item";
export {
  FULLSCREEN_CLOSE_BUTTON,
  FULLSCREEN_IMAGE_ITEM,
  FULLSCREEN_ROOT,
  FULLSCREEN_TOGGLE_BUTTON
};
//# sourceMappingURL=data-hooks.js.map
